/**
 * Expression Evaluator Types
 *
 * Provides types for the safe expression evaluator used in SDUI compute actions.
 */
/**
 * Allowed function names
 */
export const ALLOWED_FUNCTIONS = [
    'Number',
    'String',
    'Boolean',
    'Math.round',
    'Math.floor',
    'Math.ceil',
    'Math.abs',
    'Math.min',
    'Math.max',
    'Math.pow',
    'JSON.parse',
    'Array.isArray',
];
/**
 * Allowed method names for string/array operations
 */
export const ALLOWED_METHODS = [
    // String methods
    'includes',
    'indexOf',
    'lastIndexOf',
    'startsWith',
    'endsWith',
    'substring',
    'slice',
    'toLowerCase',
    'toUpperCase',
    'trim',
    'split',
    'charAt',
    'charCodeAt',
    'replace',
    // Array methods (read-only)
    'join',
    'concat',
    'length', // technically a property but handled same way
];
/**
 * Allowed root context identifiers
 */
export const ALLOWED_CONTEXTS = ['input', 'output', 'payload'];
/**
 * Security limits
 */
export const EXPRESSION_LIMITS = {
    /** Maximum expression length in characters */
    MAX_LENGTH: 1000,
    /** Maximum AST node count (100 allows calculator-style nested ternaries) */
    MAX_NODES: 100,
    /** Maximum recursion/nesting depth */
    MAX_DEPTH: 10,
    /** Maximum string literal length */
    MAX_STRING_LENGTH: 200,
};
//# sourceMappingURL=types.js.map